/**
 * Canicule — tagline rotator + star signal sequence.
 */
(function () {
  'use strict';

  var TAGLINES = [
    'Canicule, un vent de fraîcheur.',
    'Chaleur ou fraîcheur ? Canicule.',
    'Canicule un jour, Canicule toujours.',
    "L'air doit circuler.",
    'Retours réels sur modèles comparables.'
  ];

  var TAGLINE_MS = 4800;
  var STAR_STEP_MS = 220;
  var STAR_BLINK_MS = 1350;
  var STAR_GLOW_MS = 1600;
  var STAR_WIND_MS = 900;
  var STAR_PAUSE_MS = 400;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initTaglineRotator(root) {
    if (!root || root.dataset.caniculeTaglineInit === 'true') return;
    root.dataset.caniculeTaglineInit = 'true';

    var line = root.querySelector('.canicule-tagline__text');
    if (!line) return;

    var index = 0;
    line.textContent = TAGLINES[0];
    line.classList.add('is-active');

    if (prefersReducedMotion() || TAGLINES.length < 2) return;

    window.setInterval(function () {
      line.classList.remove('is-active');
      window.setTimeout(function () {
        index = (index + 1) % TAGLINES.length;
        line.textContent = TAGLINES[index];
        line.classList.add('is-active');
      }, 380);
    }, TAGLINE_MS);
  }

  function resetStars(stars, root) {
    root.classList.remove('is-wind');
    stars.forEach(function (star) {
      star.classList.remove('is-lit', 'is-blink', 'is-glow');
    });
  }

  function playStarSequence(root) {
    if (root._caniculeStarPlaying) return;
    root._caniculeStarPlaying = true;

    var stars = root.querySelectorAll('[data-star-index]');
    if (!stars.length) {
      root._caniculeStarPlaying = false;
      return;
    }

    if (prefersReducedMotion()) {
      stars.forEach(function (star) {
        star.classList.add('is-lit');
      });
      root._caniculeStarPlaying = false;
      return;
    }

    resetStars(stars, root);

    var i;
    for (i = 0; i < 4; i += 1) {
      (function (idx) {
        window.setTimeout(function () {
          stars[idx].classList.add('is-lit');
        }, idx * STAR_STEP_MS);
      })(i);
    }

    var fifthDelay = 4 * STAR_STEP_MS;
    window.setTimeout(function () {
      stars[4].classList.add('is-lit', 'is-blink');
    }, fifthDelay);

    window.setTimeout(function () {
      stars[4].classList.remove('is-blink');
      stars[4].classList.add('is-glow');
      root.classList.add('is-wind');
    }, fifthDelay + STAR_BLINK_MS);

    window.setTimeout(function () {
      root.classList.remove('is-wind');
    }, fifthDelay + STAR_BLINK_MS + STAR_WIND_MS);

    window.setTimeout(function () {
      resetStars(stars, root);
      root._caniculeStarPlaying = false;
      playStarSequence(root);
    }, fifthDelay + STAR_BLINK_MS + STAR_GLOW_MS + STAR_PAUSE_MS);
  }

  function initStarSignal(root) {
    if (!root || root.dataset.caniculeStarInit === 'true') return;
    root.dataset.caniculeStarInit = 'true';

    if (prefersReducedMotion()) {
      playStarSequence(root);
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            playStarSequence(root);
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.35, rootMargin: '0px 0px -5% 0px' }
      );
      observer.observe(root);
    } else {
      playStarSequence(root);
    }
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-canicule-tagline-rotator]').forEach(initTaglineRotator);
    scope.querySelectorAll('[data-canicule-star-signal]').forEach(initStarSignal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
